export default __webpack_public_path__ + "static/media/active-routes-home.5187ee51.png";